import { ResponseWrapper, PagedResults, trackerGet, decodeResult } from "./basicApi.ts";


interface ProposalDto {
  id: number;
  slug: string;
  name: string;
  description?: string;
  external_link?: string;
  ids_owners: number[];
  ids_editors: number[];
  ids_watchers: number[];
  date_record_created: string;
}


// Get a list of Proposals the logged-in user has access to
async function getProposals(): Promise<ResponseWrapper<PagedResults<ProposalDto>>> {
  const result = await trackerGet(`proposals/`, {});
  return decodeResult(result);
}


export type { ProposalDto };
export {  getProposals }
